import template from './transaction-authentication.html';
import controller from './transaction-authentication.controller'

let transactionAuthenticationComponent = {
  bindings: {},
  template,
  controller
};

export default transactionAuthenticationComponent;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/transaction-authentication/transaction-authentication.component.js